// extracted by mini-css-extract-plugin
export default {"modal":"nfa-z","modalContent":"ofa-z","footer":"pfa-z","cancelBtn":"qfa-z","disabled":"rfa-z","formWrapper":"sfa-z","fade":"tfa-z","fade-in":"ufa-z","iframe":"vfa-z"};